import { UID_REGEX } from '@/core/constants/common'
import { SortParams } from '../ReferralEarnings.hooks/useReferralEarnings'

export const isUserIdValid = (uid: string): boolean => {
  return UID_REGEX.test(uid)
}

export const formatUserId = (uid: string): string => {
  return uid.replace(/\s/g, '')
}

export const isSortedDescending = (sortParams: SortParams, column?: string) => {
  return column && sortParams.sortBy === column && !sortParams.sortDesc
}
